import Header from "../../components/Header";
import "./styles.css";

import Hero from "./components/Hero";
import Benefit from "../../components/Benefit";

import ProductAdminDemo from "../../components/ProductAdminDemo";

import LiveTvRoundedIcon from "@mui/icons-material/LiveTvRounded";
import MilitaryTechRoundedIcon from "@mui/icons-material/MilitaryTechRounded";
import SavingsRoundedIcon from "@mui/icons-material/SavingsRounded";

import Button from "../../components/Button";
import { AddRounded } from "@mui/icons-material";
import Pricing from "../../components/Pricing";
import FAQ from "../../components/FAQ";
import Footer from "../../components/Footer";

import nutritionist from "../../assets/personas/nutricionista.png";
import influencer from "../../assets/personas/influencer.png";
import personal from "../../assets/personas/personal-trainer.png";

import founderChip from "../../assets/photos/founder-chip.svg";

import banner from "../../assets/mockups/app-with-photos-bg.png";

import Benefits from "./components/Benefits";

const contactURL = "https://api.whatsapp.com/send/?phone=5511919829965";

export default function InfluencersInvite() {
  function handleGoToSubscribe() {
    window.location.href = "https://vxaeo2lhld7.typeform.com/to/yXGvZqDD";
  }

  return (
    <main className="influencers-invite-page">
      <Header displayLogin={false} />

      <div className="hero-banner mt-2">
        <img src={banner} className="hero-image" />
      </div>

      <div className="body-container">
        <Hero onCTA={handleGoToSubscribe} />

        <div className="personas-box mt-5">
          <h4>Se você é...</h4>

          <div className="personas mt-2">
            <div className="persona-container">
              <img src={nutritionist} className="persona-image" />
              <span>Nutricionista</span>
            </div>
            <div className="persona-container">
              <img src={influencer} className="persona-image" />
              <span>Influencer</span>
            </div>
            <div className="persona-container">
              <img src={personal} className="persona-image" />
              <span>Personal Trainer</span>
            </div>
          </div>

          <h4 className="mt-3 mb-4">
            <b>Então sim, o Ginastee é para você!</b>
          </h4>
        </div>
      </div>

      <div className="mt-3 px-1 py-1 alert-container">
        <h5>
          Assista ao vídeo abaixo para estar à frente de 99% das pessoas, que
          ficarão assistindo você dominar o mercado fitness
        </h5>
      </div>

      <div className="body-container pt-2">
        <img src={founderChip} className="founder-chip" />

        <div className="vsl-container mt-2"></div>

        <Button.Main
          className="center mt-4 mb-2"
          onPress={handleGoToSubscribe}
          text="Aplicar para os deciders"
          rightIcon={<AddRounded />}
        />

        <div className="alert px-2 py-2 mt-4">
          <h4>
            <b>Aviso</b>
          </h4>
          <h5>
            Esta <b>não é uma plataforma de cursos</b>, muito menos uma área de
            membros. Trata-se da primeira rede social fitness brasileira, onde{" "}
            <b>influencers criam assinaturas e monetizam</b> através da sua
            audiência.
          </h5>
        </div>

        <h2 style={{ textAlign: "center" }} className="mt-6">
          #MakeItHappen
        </h2>
      </div>

      <Footer
        title={
          <>
            É influencer fitness e já
            <br /> fatura com as redes sociais?
          </>
        }
        subtitle={
          <>
            Nosso time te guiará em toda a jornada: basta entrar em contato
            conosco através do botão abaixo.
          </>
        }
        ctaText="Conversar com um especialista"
        ctaAction={() => (window.location.href = contactURL)}
      />
    </main>
  );
}
